import { useEffect } from "react";

const Step5 = ({ bookingData, paymentLink, handleCreatePayment, disabled, setIsSuccess, t }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8 text-center">
          <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 bg-blue-100 rounded-full">
            <i className="text-4xl text-blue-500 fa-solid fa-credit-card"></i>
          </div>
          <h3 className="mb-2 text-2xl font-bold text-gray-800">{t("payment_information") || "Payment Information"}</h3>
          <p className="text-gray-600">
            {t("review_payment_details") || "Please review your payment details and proceed to payment"}
          </p>
        </div>

        {bookingData && (
          <div className="p-6 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm">
            <h4 className="pb-3 mb-4 text-lg font-semibold text-gray-800 border-b">
              {t("booking_summary") || "Booking Summary"}
            </h4>

            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">{t("invoice_number") || "Invoice Number"}:</span>
                <span className="font-semibold text-gray-800">{bookingData?.booking_invoice?.invoice?.number}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">{t("customer_name") || "Customer Name"}:</span>
                <span className="font-semibold text-gray-800">{bookingData?.customer?.name}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">{t("email") || "Email"}:</span>
                <span className="font-semibold text-gray-800">{bookingData?.customer?.email}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">{t("phone") || "Phone"}:</span>
                <span className="font-semibold text-gray-800">{bookingData?.customer?.phone}</span>
              </div>

              <div className="pt-3 mt-4 border-t border-gray-200">
                <div className="flex justify-between">
                  <span className="text-lg font-semibold text-gray-800">{t("total_amount") || "Total Amount"}:</span>
                  <span className="text-2xl font-bold text-[#f5272b]">
                    Rp {bookingData?.total_price?.toLocaleString("id-ID")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="p-6 mb-6 rounded-lg bg-blue-50">
          <div className="flex items-start">
            <i className="mt-1 mr-3 text-blue-500 fa-solid fa-info-circle"></i>
            <div className="text-sm text-gray-700">
              <p className="mb-2 font-semibold">{t("payment_instructions") || "Payment Instructions"}:</p>
              <ul className="pl-5 space-y-1 list-disc">
                <li>{t("payment_instruction_1") || "Click the button below to create payment invoice"}</li>
                <li>{t("payment_instruction_2") || "You will be redirected to Xendit payment page"}</li>
                <li>{t("payment_instruction_3") || "Complete your payment using available payment methods"}</li>
                <li>{t("payment_instruction_4") || "You will receive confirmation email after successful payment"}</li>
              </ul>
            </div>
          </div>
        </div>

        {paymentLink && (
          <div className="p-4 mb-6 border-l-4 border-green-500 bg-green-50">
            <div className="flex items-center">
              <i className="mr-3 text-green-500 fa-solid fa-check-circle"></i>
              <div>
                <p className="font-semibold text-green-800">
                  {t("payment_link_created") || "Payment link has been created!"}
                </p>
                <p className="text-sm text-green-700">
                  {t("click_below_to_proceed") || "Click the button below to proceed to payment"}
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="flex gap-4">
          {!paymentLink && (
            <button
              type="button"
              onClick={handleCreatePayment}
              disabled={disabled}
              className={`flex-1 py-4 px-6 rounded-lg font-bold text-white transition-all ${
                disabled ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600 transform hover:scale-105"
              }`}
            >
              {disabled ? (
                <span className="flex items-center justify-center">
                  <i className="mr-2 fa-solid fa-spinner fa-spin"></i>
                  {t("creating_invoice") || "Creating Invoice..."}
                </span>
              ) : (
                <span className="flex items-center justify-center">
                  <i className="mr-2 fa-solid fa-file-invoice"></i>
                  {t("create_payment_invoice") || "Create Payment Invoice"}
                </span>
              )}
            </button>
          )}

          {paymentLink && (
            <a
              href={paymentLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center flex-1 px-6 py-4 font-bold text-white transition-all transform bg-green-500 rounded-lg hover:bg-green-600 hover:scale-105"
            >
              <i className="mr-2 fa-solid fa-external-link-alt"></i>
              {t("proceed_to_payment") || "Proceed to Payment"}
            </a>
          )}
        </div>

        {paymentLink && (
          <button
            type="button"
            onClick={() => setIsSuccess(true)}
            className="w-full px-6 py-3 mt-4 font-semibold text-gray-700 transition-colors bg-gray-200 rounded-lg hover:bg-gray-300"
          >
            {t("done") || "I've completed the payment"}
          </button>
        )}
      </div>
    </div>
  );
};

export default Step5;
